export enum FirmwareUpdateSourceOption {
  FACTORY = 1,
  APP = 2,
  MOBILE_APP = 3,
}
